import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import LoginPageForm from "./LoginPageForm";

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: "50px", // space for fixed footer
  },
}));

function LoginPage(props) {
  useEffect(() => {}, []);

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <LoginPageForm />
    </div>
  );
}

export default LoginPage;
